module.exports = __webpack_public_path__ + "img/vrc.acfd9c04.svg";